import { frontendURL } from '../../../../helper/URLHelper';
import ProfileWrapper from '../profile/Wrapper.vue';
import Chatflow from './Chatflow.vue';

export default {
  routes: [
    {
      path: frontendURL('accounts/:accountId/settings/chatflow'),
      component: ProfileWrapper,
      props: {
        keepAlive: false,
      },
      children: [
        {
          path: '',
          name: 'settings_chatflow',
          component: Chatflow,
          meta: {
            permissions: ['administrator'],
          },
        },
      ],
    },
  ],
};
